import ColoredText from '@webstollen/react-native/lib/components/CustomText/ColoredText'
import React from 'react'
import { View } from 'react-native'
import useStyles from './styles'

const ComponentWrapper = ({ children, title }: { children: React.ReactNode; title: string }) => {
  const styles = useStyles()
  return (
    <View style={styles.wrapper}>
      <ColoredText style={styles.title}>{title}</ColoredText>
      <View>
        <>{children}</>
      </View>
    </View>
  )
}

export default ComponentWrapper
